import { render, staticRenderFns } from "./VotesList.vue?vue&type=template&id=a2cdbc00&scoped=true&"
import script from "./VotesList.vue?vue&type=script&lang=js&"
export * from "./VotesList.vue?vue&type=script&lang=js&"
import style0 from "./VotesList.vue?vue&type=style&index=0&id=a2cdbc00&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cdbc00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
